module.exports = __webpack_public_path__ + "static/media/empty.d9875da8.svg";